export const emailSettingsProps = {
  notes: {
    title: 'Create Notes via Email',
    description:
      'Easily convert emails into Notes! Simply forward relevant emails to the ID below, and they will automatically appear on your Notes page—saving you the hassle of manual entry. The note will be automatically created and associated with the client and client contact based on the sender information.',
    emailPrefix: 'notes',
    pageType: 'NOTES_FROM_EMAIL',
  },
  leads: {
    title: 'Create Leads via Email',
    description:
      'Easily convert emails into leads! Simply forward relevant emails to the ID below, and they will automatically appear on your Leads page—saving you the hassle of manual entry. It will Auto assign the lead owner and the client and client contact based on the sender information. Additionally, leads can be instantly created when you receive a positive response from any campaign participant.',
    emailPrefix: 'leads',
    pageType: 'LEADS_FROM_EMAIL',
  },
};
